<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="cancelService()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button (click)="scanBarcode()" size="small" color="medium">
                <ion-icon name="barcode" slot="icon-only"></ion-icon>
            </ion-button>
            <ion-button (click)="openModalJobDetails(null)">
                <ion-icon slot="icon-only" name="add"></ion-icon>
            </ion-button>
            <ion-button (click)="showFilters()">
                <ion-icon slot="icon-only" name="filter-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-searchbar placeholder="Search Jobs" debounce="300" [(ngModel)]="queryText"></ion-searchbar>
    </ion-toolbar>

    <ion-button *ngIf="mobileConfiguration.mobilehireFilterByCollectedAndVerified" expand="block" (tap)="toggleVerifiedJobs()" [color]="toggleButtonStyle" >{{toggleButtonText}}</ion-button>

    <!--ion-grid no-padding>
        <ion-row no-padding>
            <ion-col size="12" no-padding>
                <ion-item lines="none">
                   
                </ion-item>
            </ion-col>
        </ion-row>
    </ion-grid-->
</ion-header>
<ion-content>
    <ion-refresher slot="fixed" (ionRefresh)="refreshDocs($event)">
        <ion-refresher-content
                pullingIcon="arrow-dropdown"
                pullingText="Pull to refresh"
                refreshingSpinner="circles"
                refreshingText="Fetching Documents...">
        </ion-refresher-content>
    </ion-refresher>
    
    <ion-virtual-scroll *ngIf="!mobileConfiguration.mobilehireFilterByCollectedAndVerified" [items]="jobList | filterJobs: queryText">
        
        <ion-item *virtualItem="let job" (click)="openModalJobDetails(job)" class="ion-activatable">
            <ion-label>
                <h3>{{job.jobNumber}} - {{job.scheduledDate | date:'dd/MM/yyyy'}}
                    <span *ngIf="job.engineer">- {{job.engineer ? job.engineer.name : ''}}</span>
                </h3>
                <h3>{{job.jobType}}</h3>
                <h4 *ngIf="job.servicedItem.pdesc"
                    style="color: #1aacc3">{{job.servicedItem.pdesc}}
                    -{{job.servicedItem.reg}}</h4>
                <h4 *ngIf="job.servicedItem.serial" style="color: #1aacc3">Serial
                    - {{job.servicedItem.serial}}</h4>
                <h4 *ngIf="job.servicedItem.plu"
                    style="color: #1aacc3">{{job.servicedItem.plu}}</h4>
                <h4 style="color: #1aacc3">{{job.servicedItem.description}}</h4>
                <h4 *ngFor="let item of job.bundleItems">{{item.qty}} - {{item.description}}</h4>
                <p *ngIf="job.binLocation && job.binLocation.locationTag"> Bin Location -
                    <span style="color: cornflowerblue;"> {{job.binLocation.locationTag}} </span>
                </p>

                <p>{{job.noteText}}</p>
            </ion-label>
            <ion-ripple-effect></ion-ripple-effect>
        </ion-item>

    </ion-virtual-scroll>

    <!-- Enable sliding for Verify and Pending , if we are using that filter option-->

    <ion-virtual-scroll *ngIf="mobileConfiguration.mobilehireFilterByCollectedAndVerified" [items]="jobList | filterJobs: queryText">
        <ion-item-sliding #assignSlider *virtualItem="let job" class="ion-activatable" (ionSwipe)="handleAssigningDocument(job,assignSlider)">
            <ion-item  (click)="openModalJobDetails(job)" class="ion-activatable">
                <ion-label>
                    <h3>{{job.jobNumber}} - {{job.scheduledDate | date:'dd/MM/yyyy'}}
                        <span *ngIf="job.engineer">- {{job.engineer ? job.engineer.name : ''}}</span>
                    </h3>
                    <h3 *ngIf="job.cust">
                        {{job.cust.name}}
                    </h3>

                    <h2 *ngIf="job.jobStatus !== 200 " style="color: crimson;" >(Collected)</h2>
                    <h2 *ngIf="job.jobStatus === 200 " style="color: green;" >(Verified)</h2>
                    
                    <h3>{{job.jobType}}</h3>
                    <h4 *ngIf="job.servicedItem.pdesc"
                        style="color: #1aacc3">{{job.servicedItem.pdesc}}
                        -{{job.servicedItem.reg}}</h4>
                    <h4 *ngIf="job.servicedItem.serial" style="color: #1aacc3">Serial
                        - {{job.servicedItem.serial}}</h4>
                    <h4 *ngIf="job.servicedItem.plu"
                        style="color: #1aacc3">{{job.servicedItem.plu}}</h4>
                    <h4 style="color: #1aacc3">{{job.servicedItem.description}}</h4>
                    <h4 *ngFor="let item of job.bundleItems">{{item.qty}} - {{item.description}}</h4>
                    <p *ngIf="job.binLocation && job.binLocation.locationTag"> Bin Location -
                        <span style="color: cornflowerblue;"> {{job.binLocation.locationTag}} </span>
                    </p>

                    <p>{{job.noteText}}</p>
                </ion-label>
                <ion-ripple-effect></ion-ripple-effect>
            </ion-item>
            <ion-item-options side="start">
                <ion-item-option color="none" class="ion-float-right">
                    <ion-button [color]="toggleSwipeStyle" (click)="handleAssigningDocument(job,assignSlider)">
                        <ion-icon name="arrow-forward" slot="icon-only"></ion-icon>
                       {{ toggleSwipeText }}
                    </ion-button>
                </ion-item-option>
            </ion-item-options>
        </ion-item-sliding>

    </ion-virtual-scroll>


</ion-content>

<ion-footer *ngIf="loadingJobs">
    <p class="ion-text-center" style="color: darkgrey">Syncing jobs...</p>
</ion-footer>
